export type ProviderVendor = 'claude' | 'openai' | 'ollama' | 'bedrock'

export interface ProviderOption {
  vendor: ProviderVendor
  label: string
}

export const PROVIDER_OPTIONS: ProviderOption[] = [
  { vendor: 'claude', label: 'Anthropic Claude' },
  { vendor: 'openai', label: 'OpenAI' },
  { vendor: 'ollama', label: 'Ollama (self-hosted)' },
  { vendor: 'bedrock', label: 'AWS Bedrock (Claude)' },
]

export const CLAUDE_MODELS = [
  'claude-opus-4-8',
  'claude-opus-4-7',
  'claude-opus-4-6',
  'claude-sonnet-4-6',
  'claude-haiku-4-5-20251001',
]

export const OPENAI_MODELS = ['gpt-5.4', 'gpt-5.4-mini', 'gpt-5.4-nano']

export const BEDROCK_MODELS = [
  'claude-opus-4-8',
  'claude-opus-4-7',
  'claude-opus-4-6',
  'claude-sonnet-4-6',
  'claude-haiku-4-5-20251001',
]

export const DEFAULT_MODEL: Record<ProviderVendor, string> = {
  claude: 'claude-sonnet-4-6',
  openai: 'gpt-5.4',
  ollama: 'llama3.1:8b',
  bedrock: 'claude-sonnet-4-6',
}

export function getStaticModelsForProvider(vendor: ProviderVendor): string[] {
  if (vendor === 'claude') return CLAUDE_MODELS
  if (vendor === 'openai') return OPENAI_MODELS
  if (vendor === 'bedrock') return BEDROCK_MODELS

  return [] // Ollama is dynamic
}
